/** The part of the Web Storage API that core uses; web passes `window.localStorage`. */
export interface LocalStorage {
  getItem: (key: string) => string | null | undefined;
  setItem: (key: string, value: string) => void;
  removeItem: (key: string) => void;
  clear: () => void;
}

let localStorageStub: { [key: string]: string } = {};
const localStorageFallback = {
  setItem: (key: string, value: string) => {
    localStorageStub[key] = value;
    // biome-ignore lint/suspicious/noConsole: fallback until localStorageInterfaceInit runs
    console.error('initialize localStorageInterface with localStorageInterfaceInit or initializeUtilsCore first...');
  },
  getItem: (key: string): string | undefined => localStorageStub[key],
  removeItem: (key: string) => delete localStorageStub[key],
  clear: () => {
    localStorageStub = {};
  },
  key: (index: number): string | undefined => Object.keys(localStorageStub)[index],
  length: () => Object.keys(localStorageStub).length,
};
export let localStorageInterface: LocalStorage = localStorageFallback;

export const localStorageInrerfaceInit = (storage: LocalStorage | undefined): void => {
  localStorageInterface = storage || localStorageInterface;
};
